class ItemsAccordion {
  constructor(el) {
    this.el = el;
    this.items = this.el.querySelectorAll(".areas-item");
    for (let accordion of this.items) {
      new ItemsAccordionItem(accordion);
    }
    this.handleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.handleResize);
  }

  handleResize() {
    for (let accordionItem of this.items) {
      const item = accordionItem.querySelector(".areas-item__content");
      if (accordionItem.querySelector("areas-item__button").getAttribute("aria-expanded") === "true") {
        item.style.height = 'auto';
        item.style.height = item.scrollHeight + 'px';
      }
    }
  }
}

class ItemsAccordionItem {
  constructor(el) {
    this.el = el;
    this.elButton = this.el.querySelector(".areas-item__button");
    this.elPanel = this.el.querySelector(".areas-item__content");

    this.elButton.addEventListener("click", () => {
      let accordionExpanded = this.elButton.getAttribute("aria-expanded") === "true";

      const controls = this.elButton.getAttribute("aria-controls");
      let index = "";
      if (controls) {
        const match = controls.match(/(\d+)$/);
        if (match) {
          index = match[1];
        }
      }

      if (!accordionExpanded) {
        const allItems = document.querySelectorAll(".areas-item");
        allItems.forEach(item => {
          if (item !== this.el && item.querySelector(".areas-item__button").getAttribute("aria-expanded") === "true") {
            const panel = item.querySelector(".areas-item__content");
            const button = item.querySelector(".areas-item__button");
            panel.setAttribute("tabindex", -1);
            panel.style.pointerEvents = "none";
            panel.style.transition = "height .25s cubic-bezier(.25, .1, 0, .77), opacity .2s cubic-bezier(.25, .1, 0, .77)";
            panel.style.opacity = "0";
            button.setAttribute("aria-expanded", "false");
            item.classList.remove("expanded");
            panel.style.height = "0";
          }
        });
      }

      const sideItems = document.querySelectorAll('.areas-accordion__side--item');
      sideItems.forEach(item => item.classList.remove('active', 'visible'));

      const sideContainer = document.querySelector('.areas-accordion__side');
      if (sideContainer) {
        sideContainer.classList.remove("visible");
      }

      if (!accordionExpanded) {
        this.elPanel.setAttribute("tabindex", 0);
        this.elPanel.style.pointerEvents = "all";
        this.elPanel.style.transition = "height .25s cubic-bezier(.25, .1, 0, .77), opacity .5s cubic-bezier(.25, .1, 0, .77) .2s";
        this.elPanel.style.height = this.elPanel.scrollHeight + "px";
        this.elPanel.style.opacity = "1";
        this.elButton.setAttribute("aria-expanded", "true");
        this.el.classList.add("expanded");
        this.el.scrollIntoView({ behavior: 'smooth', block: 'start' });


        if (sideContainer) {
          sideContainer.classList.add("visible");
        }

        const targetSideItem = document.querySelector(`.areas-accordion__side--item[data-index="${index}"]`);
        if (targetSideItem) {
          // targetSideItem.style.opacity = "0";
          targetSideItem.style.transition = "opacity .5s cubic-bezier(.25, .1, 0, .77)";
          targetSideItem.classList.add("active");

          setTimeout(() => {
            // targetSideItem.style.opacity = "1";
            targetSideItem.style.transition = "";
          }, 200);


        }
      } else {
        this.elPanel.setAttribute("tabindex", -1);
        this.elPanel.style.pointerEvents = "none";
        this.elPanel.style.transition = "height .25s cubic-bezier(.25, .1, 0, .77), opacity .2s cubic-bezier(.25, .1, 0, .77)";
        this.elPanel.style.opacity = "0";
        this.elButton.setAttribute("aria-expanded", "false");
        this.el.classList.remove("expanded");
        this.elPanel.style.height = "0";
      }
    });
  }
}


const initAccordions = () => {
  const accordions = document.querySelectorAll(".js-areas-list");
  if (accordions) {
    for (let accordion of accordions) {
      new ItemsAccordion(accordion);
    }
  }
};

initAccordions();
